import Props from "./Embed.types"

const Embed = ({ url }: Props) => {
  return <embed src={url} style={{ width: "100%", height: "100%" }} />
}

export default Embed
